module.exports = "https://trybtryb-legacy.web.app/img/half-transparent-special-mobile.1d4ab8f9.svg";